var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSportsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 18.75H9.37484C7.9935 18.75 6.66874 18.2013 5.69199 17.2246C4.71524 16.2478 4.1665 14.923 4.1665 13.5417C4.1665 12.1604 4.71524 10.8356 5.69199 9.85886C6.66874 8.88211 7.9935 8.33337 9.37484 8.33337H12.4998",
    stroke: "#FBD050",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 18.75H40.625C42.0063 18.75 43.3311 18.2013 44.3078 17.2246C45.2846 16.2478 45.8333 14.923 45.8333 13.5417C45.8333 12.1604 45.2846 10.8356 44.3078 9.85886C43.3311 8.88211 42.0063 8.33337 40.625 8.33337H37.5",
    stroke: "#FBD050",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 45.8334H41.6668",
    stroke: "#FBD050",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8335 30.5416V35.4166C20.8335 36.5625 19.8543 37.4583 18.8127 37.9375C16.3543 39.0625 14.5835 42.1666 14.5835 45.8333",
    stroke: "#FBD050",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1665 30.5416V35.4166C29.1665 36.5625 30.1457 37.4583 31.1873 37.9375C33.6457 39.0625 35.4165 42.1666 35.4165 45.8333",
    stroke: "#FBD050",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 4.16663H12.5V18.75C12.5 22.0652 13.817 25.2446 16.1612 27.5888C18.5054 29.933 21.6848 31.25 25 31.25C28.3152 31.25 31.4946 29.933 33.8388 27.5888C36.183 25.2446 37.5 22.0652 37.5 18.75V4.16663Z",
    stroke: "#FBD050",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsicon);
export default __webpack_public_path__ + "static/media/sports icon.d68135d23e46f6ca68e502c456ec025e.svg";
export { ForwardRef as ReactComponent };